import { useEffect, lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";

// Route-level code splitting: visitors only download the page they open
const BlogIndex = lazy(() => import("@/pages/BlogIndex"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const StudioLogin = lazy(() => import("@/pages/studio/StudioLogin"));
const StudioDashboard = lazy(() => import("@/pages/studio/StudioDashboard"));
const StudioLinkedIn = lazy(() => import("@/pages/studio/StudioLinkedIn"));
const StudioDirectors = lazy(() => import("@/pages/studio/StudioDirectors"));
const PostEditor = lazy(() => import("@/pages/studio/PostEditor"));

const PageFallback = (
  <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]">
    <div className="h-10 w-10 rounded-full border-4 border-[#5B4199]/20 border-t-[#5B4199] animate-spin" />
  </div>
);

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={PageFallback}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/studio/login" element={<StudioLogin />} />
            <Route path="/studio" element={<ProtectedRoute><StudioDashboard /></ProtectedRoute>} />
            <Route path="/studio/linkedin" element={<ProtectedRoute><StudioLinkedIn /></ProtectedRoute>} />
            <Route path="/studio/directors" element={<ProtectedRoute><StudioDirectors /></ProtectedRoute>} />
            <Route path="/studio/posts/new" element={<ProtectedRoute><PostEditor /></ProtectedRoute>} />
            <Route path="/studio/posts/:id/edit" element={<ProtectedRoute><PostEditor /></ProtectedRoute>} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster theme="light" position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
